import { DetailedHTMLProps, FC, ForwardedRef, HTMLAttributes, ReactNode, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface CardHeaderProps extends Omit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'title'> {
    title: ReactNode;
    sideContent?: ReactNode;
    ref?: ForwardedRef<HTMLDivElement>;
}

const CardHeader = forwardRef<HTMLDivElement, CardHeaderProps>((props, ref) => {
    const { title, sideContent, className, ...rest } = props;

    return (
        <div
            ref={ref}
            {...rest}
            className={twMerge('flex items-center h-16 px-6 border-b border-separator-color', className)}
        >
            <h6 className="text-grayscale-500 font-medium">{title}</h6>

            <div className="ml-auto flex items-center gap-4">{sideContent}</div>
        </div>
    );
});

export default CardHeader;
